<template>
    <svg class="stat-circle" viewBox="0 0 20 20" :style="`width: ${width}px;`">
        <circle class="bg" cx="10" cy="10" r="8"/></circle>
        <circle class="progress" cx="10" cy="10" r="8" :stroke-dashoffset="dashOffset" transform="rotate(-90, 10, 10)" /></circle>
    </svg>
</template>

<script>
export default {
    props: {
        percentage: {
            Type: Number,
            default: 0,
        },
        width: {
            type: Number,
            default: 100,
        },
    },

    computed: {
        dashOffset() {
            return -51 -((51 / 100) * parseFloat(this.percentage));
        },
    }
}

</script>

<style scoped>

.stat-circle circle.bg {
    fill: none;
    stroke: #dddddd;
    stroke-width: 2;
}
.stat-circle circle.progress {
    fill: none;
    stroke: var(--primary);
    stroke-width: 2;
    stroke-dasharray: 51 51;
    stroke-linecap: round;
}
.stat-circle text {
    font-size: 5px;
    text-anchor: middle;
    fill: #bbb;
}
</style>
